export default __webpack_public_path__ + "static/plk-case-study-78b423da1a093fdf9ca36299a91c41f2.pdf";